import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './StaticPages.css';

function NotFoundPage() {
  return (
    <main className="static-page">
      <SEO 
        title="Page Not Found - E Forum"
        description="The page you're looking for doesn't exist."
      />
      
      <div className="content-wrapper">
        <div className="error-container">
          <h1 className="error-title">404</h1>
          <h2 className="error-subtitle">Page Not Found</h2>
          <p className="error-message">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="error-actions">
            <Link to="/" className="btn-primary">Go Home</Link>
            <Link to="/search" className="btn-secondary">Search Articles</Link>
          </div>
        </div>
      </div>
    </main>
  );
}

export default NotFoundPage;